__turbopack_context__.v({
  "actions": "imDWmW_actions",
  "card": "imDWmW_card",
  "closeButton": "imDWmW_closeButton",
  "closeButtonOnPhoto": "imDWmW_closeButtonOnPhoto",
  "closeIcon": "imDWmW_closeIcon",
  "copyBlock": "imDWmW_copyBlock",
  "imageCardFadeIn": "imDWmW_imageCardFadeIn",
  "imageCardSlideUp": "imDWmW_imageCardSlideUp",
  "imagePanel": "imDWmW_imagePanel",
  "imagePanelFill": "imDWmW_imagePanelFill",
  "overlay": "imDWmW_overlay",
  "subtitle": "imDWmW_subtitle",
  "title": "imDWmW_title",
});
